import { Sparkle } from "@phosphor-icons/react";

const items = [
	"Secure Escrow",
	"Built-in Chat",
	"Verified Runners",
	"Instant Booking",
	"Proxi Private",
	"Parcel Delivery",
];

function MarqueeItems() {
	return (
		<>
			{items.map((item) => (
				<span key={item} className="mx-4 flex items-center gap-4">
					<Sparkle size={20} weight="fill" className="text-secondary" />
					{item}
				</span>
			))}
		</>
	);
}

export function Marquee() {
	return (
		<div className="bg-primary py-4 overflow-hidden flex relative rotate-1 scale-110 -mx-4 mt-4 shadow-xl z-20">
			<div className="flex whitespace-nowrap animate-marquee items-center text-white font-bold text-xl uppercase tracking-wider">
				<MarqueeItems />
				<MarqueeItems />
				<MarqueeItems />
			</div>
		</div>
	);
}
